import { useMutation, useQueryClient } from "@tanstack/react-query"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function deletePrompt(promptId: string, type: "personal" | "company" = "personal"): Promise<void> {
  return api.delete(`/explorer/prompt/${promptId}?type=${type}`)
}

export function useDeletePrompt() {
  const queryClient = useQueryClient()

  const deletePromptMutation = useMutation({
    mutationKey: queryKeys.deletePrompt,
    mutationFn: ({ promptId, type }: { promptId: string; type: "personal" | "company" }) =>
      deletePrompt(promptId, type),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.prompts })
    },
  })

  return deletePromptMutation
}
